import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 3H4v14h14v-7h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z"
}), 'LocalCafeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalCafeSharp.js
// module id = 4549
// module chunks = 2